import { Building2, Mail, Phone, UsersRound } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { formatPhone } from '@/lib/helpers';
import { toast } from 'sonner';

export default function IgrejasGrupoTab({ data = { groups: [], churches: [] } }) {
  const copyValue = async (value, label) => {
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      toast.success(`${label} copiado`);
    } catch {
      toast.error(`Não foi possível copiar ${label.toLowerCase()}`);
    }
  };

  return (
    <div className="space-y-4" data-testid="igrejas-grupo-tab">
      <div className="space-y-2">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-2">
          <div className="min-w-0">
            <h2 className="text-lg sm:text-xl font-bold text-slate-900 leading-tight" style={{ fontFamily: 'Work Sans, sans-serif' }}>Igrejas do Grupo</h2>
            <p className="text-xs sm:text-sm text-slate-500 mt-1 leading-snug max-w-2xl">Administradores e cooperadores das igrejas vinculadas ao seu grupo.</p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-1.5" data-testid="igrejas-grupo-header-badges">
          <Badge variant="outline" className="w-fit bg-white text-[10px] sm:text-xs text-slate-600 px-1.5 py-0.5" data-testid="igrejas-grupo-total">{data.churches.length} {data.churches.length === 1 ? 'igreja' : 'igrejas'}</Badge>
          {data.groups?.map((group, index) => <Badge key={`${group}-${index}`} variant="outline" className="bg-white text-[10px] sm:text-xs font-semibold text-slate-600 border-slate-200 px-1.5 py-0.5 max-w-full truncate" data-testid={`igrejas-grupo-badge-${index}`}>{group}</Badge>)}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
        {data.churches.map(church => {
          const admin = (church.admins || [])[0] || null;
          return (
          <Card key={church.church_id} className="border-slate-200 shadow-sm" data-testid={`igrejas-grupo-card-${church.church_id}`}>
            <CardContent className="p-3">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-full bg-blue-50 text-blue-700 flex items-center justify-center flex-shrink-0"><Building2 className="w-4 h-4" /></div>
                <div className="min-w-0 flex-1">
                  <p className="font-semibold text-slate-900 truncate">{church.name}</p>
                  <p className="text-xs text-slate-500">{[church.city, church.state].filter(Boolean).join(' - ') || 'Local não informado'}</p>
                  {admin ? (
                    <div className="mt-2 space-y-1" data-testid={`igrejas-grupo-admin-${admin.user_id}`}>
                      <p className="text-sm font-medium text-slate-800 truncate">{admin.name || admin.email}</p>
                      <button type="button" onClick={() => copyValue(admin.email, 'E-mail')} className="block w-full truncate text-left text-xs text-slate-500 transition-colors hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-200 rounded" data-testid={`igrejas-grupo-copy-email-${admin.user_id}`} title="Copiar e-mail">
                        <Mail className="w-3 h-3 inline mr-1" />{admin.email}
                      </button>
                      <button type="button" onClick={() => copyValue(admin.phone, 'WhatsApp')} disabled={!admin.phone} className="block w-full truncate text-left text-xs text-slate-500 transition-colors hover:text-blue-700 disabled:cursor-default disabled:hover:text-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-200 rounded" data-testid={`igrejas-grupo-copy-phone-${admin.user_id}`} title="Copiar WhatsApp">
                        <Phone className="w-3 h-3 inline mr-1" />{admin.phone ? formatPhone(admin.phone) : 'sem WhatsApp'}
                      </button>
                      <p className="text-xs text-slate-500"><UsersRound className="w-3 h-3 inline mr-1" />{admin.idade_anos === null || admin.idade_anos === undefined ? 'Idade não informada' : `${admin.idade_anos} ${admin.idade_anos === 1 ? 'ano' : 'anos'} idade`} <span className="text-slate-300">/</span> {admin.tempo_ministerio_anos === null || admin.tempo_ministerio_anos === undefined ? 'tempo não informado' : `${admin.tempo_ministerio_anos} ${admin.tempo_ministerio_anos === 1 ? 'ano' : 'anos'} ministério`}</p>
                    </div>
                  ) : <p className="mt-2 text-sm text-slate-400" data-testid={`igrejas-grupo-empty-admins-${church.church_id}`}>Nenhum administrador cadastrado</p>}
                </div>
              </div>
            </CardContent>
          </Card>
          );
        })}
      </div>
    </div>
  );
}